module.exports = __webpack_public_path__ + "static/kitchen-prep.88744794.jpg";